import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { NxModule } from '@nrwl/angular';
import { AuthenticationModule } from '@quorum/authentication';
import { environment } from '@quorum/environments';
import { ServiceLaneDropdownsModule } from '@quorum/service-lane-dropdowns';
import { AddressesEntityModule, AssociatesEntityModule } from '@quorum/sha-entities/associates';
import {
  AppointmentCaseEntityModule,
  AppointmentsEntityModule,
  ServiceGroupEntityModule,
  QuoteLinesEntityModule,
  ServiceAppointmentDeclinedOperationsEntityModule,
  WorkOrderCaseEntityModule,
  WorkOrderDeclinedOperationsEntityModule,
} from '@quorum/sha-entities/fixed-operations';
import { MessageTransactionMessagePreferenceEntityModule } from '@quorum/sha-entities/communicator';
import { VehiclesEntityModule } from '@quorum/sha-entities/vehicle';
import { ShaRouterFeatureStateModule } from '@quorum/sha-router';
import { ServiceLaneEffects } from './+state/service-lane.effects';
import { ServiceLaneFacade } from './+state/service-lane.facade';
import { serviceLaneReducer } from './+state/service-lane.reducer';
import { ShaMediaModule } from '@quorum/sha-media';
import { PowerLaneAnalyticsModule } from '@quorum/power-lane-analytics';
import { HyundaiMenuNgrxModule } from '@quorum/hyundai-menu-ngrx';
import { SvcVehicleDiagnosticsRootModule } from '@quorum/svc-vehicle-diagnostics-root';

@NgModule({
  imports: [
    AuthenticationModule,
    CommonModule,
    NxModule.forRoot(),
    StoreModule.forRoot(
      { serviceLane: serviceLaneReducer },
      {
        metaReducers: !environment.production ? [] : [],
        runtimeChecks: { strictStateImmutability: false, strictActionImmutability: false },
      }
    ),
    ShaRouterFeatureStateModule,
    EffectsModule.forRoot([ServiceLaneEffects]),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
    ServiceLaneDropdownsModule,
    ServiceGroupEntityModule,
    AppointmentCaseEntityModule,
    WorkOrderCaseEntityModule,
    QuoteLinesEntityModule,
    ServiceAppointmentDeclinedOperationsEntityModule,
    AppointmentsEntityModule,
    AssociatesEntityModule,
    AddressesEntityModule,
    VehiclesEntityModule,
    MessageTransactionMessagePreferenceEntityModule,
    ShaMediaModule,
    PowerLaneAnalyticsModule,
    HyundaiMenuNgrxModule,
    WorkOrderDeclinedOperationsEntityModule,
    SvcVehicleDiagnosticsRootModule,
  ],
  providers: [ServiceLaneFacade],
})
export class ServiceLaneRootModule {}
